module.exports = __webpack_public_path__ + "static/007.thumb-02cff19833894ed81c03cf5a34f1c5f5.jpg";